export enum SupplierType{
    VENDOR = 'Vendor',
    END_CUSTOMER = 'End Customer'
}